import { FieldList, Field } from "../../utils/forms/form";

import * as Validators from '../../utils/forms/validators';
import * as CustomValidators from '../validators/post-property.validators';
import { PostPropertyProps } from "../components/post-property.component";

export const constructFields = (
  props?: PostPropertyProps
): FieldList => {
  let fields: FieldList = {
    'division': new Field(
      [Validators.required],
      null,
      'Residential'
    ),
    'category': new Field(
      [Validators.required],
      null,
      'Rent'
    ),
    'type': new Field(
      [Validators.required],
      null,
      ''
    ),

    'minLeaseTerm': new Field(
      [],
      [ CustomValidators.minLeaseTerm ],
    ),
    'rentalPrice': new Field(
      [],
      [ CustomValidators.rentalPrice ],
    ),
    'salePrice': new Field(
      [],
      [ CustomValidators.salePrice ],
    ),
    'discountedPrice': new Field(
      [],
      [ CustomValidators.discountedPrice ],
    ),
    'pricePerSqm': new Field(
      [],
      [ CustomValidators.pricePerSqm ],
    ),
    'maxPrice': new Field(
      [],
      null,
    ),

    'ownerReceipt': new Field(
      [],
      [ CustomValidators.ownerReceipt ],
    ),

    'associationDuesIncluded': new Field(
      [],
      [ CustomValidators.associationDuesIncluded ]
    ),

    'associationDues': new Field(
      [],
      [ CustomValidators.associationDues ],
      ''
    ),

    'floorArea': new Field(
      [],
      [ CustomValidators.floorArea ],
      ''
    ),
    'lotArea': new Field(
      [],
      [ CustomValidators.lotArea ],
      ''
    ),

    'furnishing': new Field(
      [],
      [ CustomValidators.furnished ],
      ''
    ),
    'condition': new Field(
      [],
      [ CustomValidators.condition ],
      ''
    ),

    'bedrooms': new Field(
      [],
      [ CustomValidators.bedrooms ]
    ),
    'bathrooms': new Field(
      [],
      [ CustomValidators.bathrooms ]
    ),
    'restRoom': new Field(
      [],
      null
    ),
    'dateAvailability': new Field(
      [Validators.required],
      null,
    ),

    // Amenities
    'aircon': new Field(
      [],
      null,
      ''
    ),
    'balcony_terrace': new Field(
      [],
      null,
      ''
    ),
    'cableTv': new Field(
      [],
      null,
      ''
    ),
    'clubhouse': new Field(
      [],
      null,
      ''
    ),'den': new Field(
      [],
      null,
      ''
    ),
    'functionRoom': new Field(
      [],
      null,
      ''
    ),
    'garden': new Field(
      [],
      null,
      ''
    ),
    'gym': new Field(
      [],
      null,
      ''
    ),
    'internet': new Field(
      [],
      null,
      ''
    ),
    'maidsRoom': new Field(
      [],
      null,
      ''
    ),
    'petFriendly': new Field(
      [],
      null,
      ''
    ),
    'playground': new Field(
      [],
      null,
      ''
    ),
    'porch_lanai': new Field(
      [],
      null,
      ''
    ),
    'security': new Field(
      [],
      null,
      ''
    ),
    'swimmingPool': new Field(
      [],
      null,
      ''
    ),

    '__hasParking': new Field(
      [],
      null,
      ''
    ),
    'parkingSpaces': new Field(
      [],
      [ CustomValidators.parkingSpaces ],
      ''
    ),

    'videoUrl': new Field(
      [],
      null
    ),

    'contactName': new Field(
      [],
      null,
      ''
    ),
    'contactEmail': new Field(
      [],
      null,
      ''
    ),
    'contactNumber': new Field(
      [],
      null,
      ''
    ),

    'notes': new Field(
      [],
      null
    ),
  }

  return fields;
};